module.exports = __webpack_public_path__ + "media/images/av-icon_w16-7ff8b34e51903d667067662821f0fc4a.png";